import React, { useState } from 'react';
import CalcAccordion from '../../../CalcAccordion/CalcAccordion';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { ReactComponent as GeneratingIco } from '../../../../../../assets/svg/generating.svg';
import { ReactComponent as OkSvg } from '../../../../../../assets/svg/ok.svg';
import { ReactComponent as ErrorSvg } from '../../../../../../assets/svg/doc-err.svg';
import { ReactComponent as EmptySvg } from '../../../../../../assets/svg/doc-empty.svg';
import ResultFilesModal from '../../../CalcResultFilesModal/ResultFilesModal';
import Tooltip from '@mui/material/Tooltip';

import pageStyles from '../../../component.module.scss';
import styles from './QuestionsList.module.scss';

const TooltipRender = ({ tooltipText, iconWidth = 20, iconHeight = 20, Icon }) => (
  <Tooltip
    slotProps={{
      tooltip: {
        sx: {
          fontFamily: 'Montserrat',
          fontSize: '12px',
          padding: '12px 20px',
          border: 'none',
          borderRadius: '12px',
          color: '#FFFFFF',
          backgroundColor: '#999999',
        },
      },
    }}
    title={tooltipText}
    placement="top"
    describeChild
  >
    <span style={{ display: 'block', width: iconWidth, height: iconHeight }}>
      <Icon style={{ width: iconWidth, height: iconHeight, flexShrink: 0 }} />
    </span>
  </Tooltip>
);

const QuestionsList = ({ params }) => {
  const { report, resultsFilesList, resultsFilesCodes, statuses } = params;
  const [viewAnswerId, setViewAnswerId] = useState(null);

  const onExpandClick = (Qid) => {
    setViewAnswerId((value) => (value === Qid ? null : Qid));
  };

  const getQuestionIco = (question) => {
    switch (question.state) {
      case statuses.PROCESSING:
        return <GeneratingIco className={pageStyles.rotating} />;
      case statuses.SUCCESS:
        return <OkSvg />;
      case statuses.ERROR:
        return <ErrorSvg />;
      case statuses.NO_DATA:
        return <EmptySvg />;
      default:
        return <div />;
    }
  };

  const getQuestionTooltip = (question) => {
    switch (question.state) {
      case statuses.PROCESSING:
        return 'Generating an answer.';
      case statuses.SUCCESS:
        return 'Answer successfully generated.';
      case statuses.ERROR:
        return 'Is there something wrong. See the file list for details.';
      case statuses.NO_DATA:
        return 'There is no data in the files to answer.';
      default:
        return '';
    }
  };

  const questionRender = (question) => (
    <div key={question.id} className={styles.questionBlock}>
      <div className={styles.labelBlock}>Question:</div>
      <div>{question.questionText}</div>
      {question.answerText ? (
        <>
          <div onClick={() => onExpandClick(question.id)} className={styles.labelBlock}>
            <div>Answer:</div>
            {viewAnswerId === question.id ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </div>
          {viewAnswerId === question.id && (
            <div>
              <div>{question.answerText}</div>
            </div>
          )}
        </>
      ) : (
        <div className={styles.labelBlock}>No answer</div>
      )}
      {resultsFilesCodes.includes(question.id) && (
        <div className={styles.fileButton}>
          {TooltipRender({
            tooltipText: getQuestionTooltip(question),
            Icon: () => getQuestionIco(question),
          })}
          <ResultFilesModal
            params={{
              resultsFilesList,
              resultsFilesCodes,
              code: question.id,
            }}
          />
        </div>
      )}
    </div>
  );

  return (
    <>
      <div className={styles.questionsListBlock}>
        <>
          {report && report.length ? (
            <>
              {report.map((topTopic) => (
                <div className={styles.topTopic}>
                  <CalcAccordion
                    title={topTopic.topicText}
                    key={topTopic.id}
                    titleStyle={styles.topicTitle}
                  >
                    {topTopic.questions.length > 0 || topTopic.subtopic.length > 0 ? (
                      <>
                        {topTopic.questions.map((question) => questionRender(question))}
                        {topTopic.subtopic.map((subtopic) => (
                          <CalcAccordion
                            title={subtopic.topicText}
                            key={subtopic.id}
                            titleStyle={styles.topicTitle}
                          >
                            {subtopic.questions.length > 0 ? (
                              <>{subtopic.questions.map((question) => questionRender(question))}</>
                            ) : (
                              <div className={styles.questionBlock}>No questions</div>
                            )}
                          </CalcAccordion>
                        ))}
                      </>
                    ) : (
                      <div className={styles.questionBlock}>No questions</div>
                    )}
                  </CalcAccordion>
                </div>
              ))}
            </>
          ) : (
            <div>No available data</div>
          )}
        </>
      </div>
    </>
  );
};

export default QuestionsList;
